import { ISet } from '../../../_models/models';
import { set as Set_1 } from './1';
import { set as Set_2 } from './2';

export const Sets: ISet[] = [Set_1, Set_2];
